<template>
  <div class="mx-4">
    <h4 v-show="!cargando" class="text-center"> Inscripciones mes de <b>{{getMes()}}</b> sede: <b>{{sedename}}</b> </h4>
    <router-link v-show="!cargando" to="rankingall" title="Titulo"> 
      Ir al tablero general 
      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-bar-chart-line-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z"/>
      </svg>
    </router-link>

    <div v-show="cargando" class="loader-spin" style="margin: 0 auto;"></div>

    <div class="row">
        <div v-show="primero.info.id" class="col-sm-4 col-sm-offset-4" :title="getTitle(primero)">
            <img :src="primero.info.foto" alt="ASESOR" class="img-responsive fotito">
            <img src="img/aaa.png" alt="ASESOR" class="medalla">
            <p class="text-center podium" style="margin-bottom:0"> <b> {{primero.info.nombre}} </b> </p>
            <p class="text-center" style="margin-top:0;margin-bottom:0"> <b>{{primero.total}}</b> </p>
        </div>
    </div>
    <div class="row">
        <div style="padding-top:4px" v-show="segundo.info.id" class="col-sm-4 col-sm-offset-2" :title="getTitle(segundo)">
            <img :src="segundo.info.foto" alt="ASESOR" class="img-responsive fotito">
            <img src="img/bbb.png" alt="ASESOR" class="medalla">
            <p class="text-center podium" style="margin-bottom:0"> <b> {{segundo.info.nombre}} </b> </p>
            <p class="text-center" style="margin-top:0"> <b>{{segundo.total}}</b> </p>
        </div>
        <div style="padding-top:4px" v-show="tercero.info.id" class="col-sm-4" :title="getTitle(tercero)">
            <img :src="tercero.info.foto" alt="ASESOR" class="img-responsive fotito">
            <img src="img/ccc.png" alt="ASESOR" class="medalla">
            <p class="text-center podium" style="margin-bottom:0"> <b> {{tercero.info.nombre}} </b> </p>
            <p class="text-center" style="margin-top:0"> <b>{{tercero.total}}</b> </p>
        </div>
    </div>
  </div>
</template>

<style lang="css">
.medalla{
  width: 20%;
  position: absolute;
  right: 20px;
  top: 15px;
}
.fotito{
  padding:12px;
  border-radius:50%;
  border:1px solid #012C5C
}
.loader-spin {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid blue; /* Blue */
  border-bottom: 4px solid blue;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@media screen and (max-width:375px){
  .fotito{
    width: 100px;
  }
}
</style>

<script>
import gql from 'graphql-tag'
export default {
  components: {},
  data() {
    return {
      location_user_pick: process.env.VUE_APP_URL_USERPICK,
      sedename:'',
      cargando:true,
      primero:{info:{}},
      segundo:{info:{}},
      tercero:{info:{}},
    };
  },
  watch:{
      '$store.state.CARGO':function( a ){
          this.listenercargo( a );
      }
  },
  methods:{
      getMes(){
          var date = new Date();
          var m = date.getMonth();
          if( m == 0 ) return 'Enero';
          else if( m == 9 ) return 'Octubre';
          else if( m == 10 ) return 'Noviembre';
          else if( m == 11 ) return 'Diciembre';
      },
      listenercargo( a ){
          if( !a ) return;
          if( this.sedename == a.sede.nombre ) return;
          this.sedename = a.sede.nombre;
          this.getInsBySede( a.idsede );
      },
      getTitle( user ){
        var ps = user.dip+user.maes+user.esp;
        var t = `Programas: ${ps}, Cursos: ${user.cur}`;
        return t;
      },
      getInsBySede( idsede ){
          this.primero = {info:{}};
          this.segundo = {info:{}};
          this.tercero = {info:{}};
          this.cargando = true;
          var date = new Date();
          var m = date.getMonth()+1;
          var d = date.getDate();
          var a = date.getFullYear();
          if( d == 1 ) d +=1;
          if( m < 10 ) m = '0'+m;
          if( d < 10 ) d = '0'+d;
          var ini = a+'-'+m+'-01';
          var fin = a+'-'+m+'-'+d;

          var sql = gql`
            query{
                getInscripcionesBySede(sede:${idsede},fechas:{fecha_ini:"${ini}",fecha_fin:"${fin}"}){
                    id
                    estado_ins
                    asesor{id,nombres,pri_apellido,seg_apellido,usuario{foto}}
                    programa{id,postgrado{id,nombre,categoria{id,nombre}}}
                }
            }`;
          this.getDatos( sql,idsede );
      },
      getDatos( sql,idsede ){
          var vue = this;
          var asesores = [{info:{},dip:0,maes:0,esp:0,cur:0,total:0}]
          this.$apollo.mutate({
            mutation: sql,
          }).then((data) => {
            var ins = data.data.getInscripcionesBySede;
            ins = ins.filter(function(e){ 
              if( idsede == 2 ){ // excluimos formacion continua
                var fc = [5071,72,5281,8382]
                return e.estado_ins > 0 && !fc.includes(e.asesor.id); // quitar ! para listar solo fc ;)
              }else{
                return e.estado_ins > 0;
              }
            });
            ins.forEach(e => {
                var nom = e.asesor.nombres+' '+e.asesor.pri_apellido;
                if( e.asesor.seg_apellido ) nom += ' '+e.asesor.seg_apellido;

                // window.console.log('>>>>asse', e.asesor);
                if(!e.asesor.usuario) e.asesor.usuario = {}
                
                
                var ase = asesores.find( x => x.info.id == e.asesor.id );
                if( !ase ) {
                    var img;
                    if( e.asesor.usuario.foto && e.asesor.usuario.foto.includes('.') ) img = this.location_user_pick+''+e.asesor.usuario.foto;
                    else img = this.location_user_pick+'userdefault.png';
                    asesores.push( {info:{id:e.asesor.id,nombre:nom,foto:img},dip:0,maes:0,esp:0,cur:0} );
                }
                ase = asesores.find( x => x.info.id == e.asesor.id );

                if( e.programa.postgrado.categoria.id == 1 ) ase.dip += 1;
                else if( e.programa.postgrado.categoria.id == 2 ) ase.esp += 1;
                else if( e.programa.postgrado.categoria.id == 3 ) ase.maes += 1;
                else ase.cur += 1;
                ase.total = ase.dip+ase.esp+ase.maes+ase.cur;

                //window.console.log( "RANKIN: ",window.stringifyObject(e) )    
            });
            asesores.sort( function(a,b){
                if( a.total > b.total ) return -1;
                if( a.total < b.total ) return 1;
                return 0;
            });
            if( asesores.length > 2 ) {
                this.primero = asesores[0];
                this.segundo = asesores[1];
                this.tercero = asesores[2];
            }
            else if( asesores.length > 1 ) {
                this.primero = asesores[0];
                this.segundo = asesores[1];
            }
            else if( asesores.length > 0 ) {
                this.primero = asesores[0];
            }
            // window.console.log( "RANKIN: ",asesores )
            this.cargando = false;
          }).catch((error) => {
            window.console.error(error);
            vue.cargando = false;
          })
      }
  },
  mounted() {
      this.listenercargo( this.$store.state.CARGO );
  },
};
</script>
